'use client';

import FlexBox from '@/components/FlexBox';
import Footer from '@/components/footer/Footer';

const EnterpriseFooter = () => {
  return (
    <FlexBox
      style={{
        width: '100%',
        backgroundColor: '#667085',
        margin: 'auto',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Footer isDark={true} />
    </FlexBox>
  );
};
export default EnterpriseFooter;
